export default __webpack_public_path__ + "static/media/noBanner.3d458e92.png";